// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"\"PalatinoLTStd-Roman\", Palatino Linotype, Book Antiqua3, Palatino, Palatino-Roman, serif"};